export enum RouteUtils {
  Home = '/',
  SelfAssessment = '/self-assessment',
  Questions = '/questions',
  End = '/end',
  Support = '/support',
}
